<template>
  <div class="monthly-invoices-tab">
    <div class="row">
      <div class="col-xs-5"><strong>Date</strong></div>
      <div class="col-xs-4"><strong></strong></div>
      <div class="col-xs-3"></div>
    </div>
    <hr class="billing-header" />
    <form action="/api/private/monthly-invoices/get-invoice" method="post" v-el:form>
      <input type="hidden" name="date" v-model="selectedDate">
      <input type="hidden" name="token" v-model="token">
    </form>
    <template v-if="months.length == 0">
      <div class="form-section-info">You do not have any invoices. Monthly invoices are available for download at the end of the month.</div>
    </template>
    <template v-for="month in months">
      <div class="row billing-item">
        <div class="col-xs-5">{{ month.month }}</div>
        <div class="col-xs-3 col-sm-4"><span v-if="month.reservations == 0 && month.credits == 0"><em>No charges were made</em></span></div>
        <div class="col-xs-3">
          <span v-if="month.reservations > 0 || month.credits > 0">
            <a @click="getInvoice(month.month)" class="btn-default btn btn-small">
            <span class="fa fa-download"></span> Download</a>
          </span>
        </div>
      </div>
    </template>
    <center><br/>
      <paging-input :options="pagingOptions" v-if="months.length"></paging-input>
    </center><br/>
  </div>
</template>

<script>
import PagingInput from '../inputs/PagingInput'

export default {
  name: 'MonthlyInvoicesTab',
  components: {
    PagingInput
  },
  data () {
    return {
      token: '',
      selectedDate: '',
      months: [],
      pagingOptions: {
        totalResults: 10,
        limit: 12,
        current: 1
      },
      searchOffset: 0,
      searchLimit: 12
    }
  },
  ready () {
    this.getMonths()
  },
  events: {
    'changePage': function (page) {
      this.searchOffset = (page - 1) * this.searchLimit
      this.getMonths()
    }
  },
  methods: {
    getInvoice (date) {
      this.token = window.sessionStorage.getItem('token')
      this.selectedDate = date
      this.$nextTick(e => {
        this.$els.form.submit()
      })
    },
    getMonths () {
      let authType = this.$route.authType
      this.$http.get(`${authType}/monthly-invoices/get-months`, { params: { offset: this.searchOffset, limit: this.searchLimit } }).then((response, status, request) => {
        this.months = response.data.array
        this.pagingOptions.current = (this.searchOffset / this.searchLimit) + 1
        this.pagingOptions.totalResults = response.data.totalMonths
        this.pagingOptions.limit = this.searchLimit
        this.$nextTick(function () {
          this.$broadcast('pagesUpdated', this.pagingOptions)
        })
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// MonthlyInvoicesTab.vue?00a8e9a4